import { Container } from "@mui/material";
import { useAuthStore } from "../../authProvider";
import ProfileClient from "../../components/client/profile-client";
import ProfilePassword from "../../components/user/profile-password";

export default function ProfilePage() {
  const { user } = useAuthStore();

  const canCreate = user?.mode_allow_create;
  const isClientRelated = user?.isClientRelated;

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Role-specific content */}
      {isClientRelated && <ProfileClient canCreate={canCreate} />}

      {/* Password Change Section - Universal */}
      <ProfilePassword />
    </Container>
  );
}
